var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"Gn-jSYF0jd0gUrDVv6pUr"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/smt";

/**
 * SMT App 客户端 Sentry 配置
 * 独立配置方案
 */

import { env } from '@lcsc-ui/utils/baseUrl';
import * as Sentry from '@sentry/nextjs';

// Sentry 配置
const sentryConfig = {
  // DSN 配置
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN || 'https://7df8b8f6eb026eec6383473263ee0368@sentry.szlcsc.com/2',

  // 环境标识
  environment: env || 'development',

  // 应用标识
  release: `nextjs-smt-app@${new Date().toISOString().split('T')[0]}`,

  // 性能监控采样率
  tracesSampleRate: env === 'pro' ? 0.001 : 0,

  // 错误采样率
  sampleRate: env === 'pro' ? 0.001 : 0.5,

  // 集成配置
  integrations: [
    // 自动追踪页面加载、路由切换、API 请求等性能数据
    Sentry.browserTracingIntegration({
      // 配置需要追踪的域名（与旧版 tracePropagationTargets 作用一致）
      tracePropagationTargets: ['localhost', /^https:\/\/smt\.szlcsc\.com/],
    }),
    // 其他集成（如会话重放）
  ],

  // 忽略的错误
  ignoreErrors: [
    'Network Error',
    'NetworkError',
    'Script error.',
    'AbortError',
    'Non-Error promise rejection captured',
  ],

  // 过滤敏感信息和调试
  beforeSend(event) {
    // 开发环境显示发送的事件
    // eslint-disable-next-line no-console
    console.log(event, env);

    // 生产环境过滤敏感信息
    if (env === 'pro') {
      if (event.user) {
        delete event.user.email;
        delete event.user.ip_address;
      }

      if (event.request && event.request.data) {
        const sensitiveKeys = ['password', 'token', 'key', 'secret'];
        sensitiveKeys.forEach((key) => {
          if (event.request.data[key]) {
            event.request.data[key] = '[Filtered]';
          }
        });
      }
    } else {
      // eslint-disable-next-line no-console
      console.log('📤 Sentry 发送事件:', event);
      // 过滤热更新产生的错误
      if (event.exception?.values?.[0]?.value?.includes('webpack hot update')) {
        return null;
      }
      // 过滤本地跨域测试的错误（如开发时调用线上接口的 CORS 错误）
      if (event.exception?.values?.[0]?.value?.includes('CORS')) {
        return null;
      }
    }

    return event;
  },

  // 设置标签
  initialScope: {
    tags: {
      component: 'nextjs-smt-app',
      platform: 'web',
    },
  },
};

// 初始化 Sentry
if (typeof window !== 'undefined') {
  Sentry.init(sentryConfig);
  // eslint-disable-next-line no-console
  console.log('🚀 Sentry 客户端初始化完成 (sentry.client.config.js)');
}

export default Sentry;
